<div class="container mt-5" [ngClass]="printActive ? 'return-view-background-print' : 'return-view-background'" style="page-break-inside: avoid;">
    <div class="row">
        <div class="col-12 text-center">
            <strong> Schedule-5<br>(Particulars of Investment Tax Credit)</strong>
        </div>
    </div>

    <div class="row my-4 px-2">
        <div class="col-sm-5">
          Name of the Taxpayer: {{returnData?.profileData?.assesName}}
        </div>
        <div class="col-sm-7 text-right">
            TIN:
            <span class="ml-3" style="white-space: nowrap;">
                <input value="{{item}}" *ngFor="let item of returnData?.profileData?.tin.split('')" class="input-default" disabled/>
            </span>
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-6">
            <strong> Particulars of Rebatable Investment:</strong>
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-12">
            <table class="table table-bordered">
                <tbody>
                    <tr>
                        <th width="10%">Serial No.
                        </th>
                        <th width="60%">Summary of Income
                        </th>
                        <th width="30%" class="text-center">Amount in Taka</th>
                    </tr>
                    <tr>
                        <td width="10%">1.</td>
                        <td width="60%">Life Insurance Premium or Contractual Deferred Annuity Paid in Bangladesh
                        </td>
                        <td width="30%">{{data?.RB_CAT_LIFE_INS_PREM | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%">2.</td>
                        <td width="60%">Contribution to Deposit Pension Scheme</td>
                        <td width="30%">{{data?.RB_CAT_DPS | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%">3.</td>
                        <td width="60%">Investment in Government Securities, Unit Certificate, Mutual Fund, ETF or Joint Investment Scheme Unit Certificate</td>
                        <td width="30%">{{savingAndUnitCertificate | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%">4.</td>
                        <td width="60%">Investment in Securities listed with Approved Stock Exchange</td>
                        <td width="30%">{{data?.RB_CAT_APPR_STOCKS_OR_SHARES | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%">5.</td>
                        <td width="60%">Contribution to Provident Fund to which Provident Fund Act, 1925 applies
                        </td>
                        <td width="30%">{{data?.RB_CAT_GPF | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%">6.</td>
                        <td width="60%">Self & Employer’s Contribution to Recognized Provident Fund </td>
                        <td width="30%">{{data?.RB_CAT_RPF | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%">7.</td>
                        <td width="60%">Contribution to Super Annuation Fund</td>
                        <td width="30%">{{data?.RB_CAT_APPR_SUPER_ANNUATION_FUND | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%">8.</td>
                        <td width="60%">Contribution to Benevolent Fund / Group Insurance Premium</td>
                        <td width="30%">{{data?.RB_CAT_BENEVOLENT_FUND_GRP_INS_PREM | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%">9.</td>
                        <td width="60%">Contribution to Zakat Fund </td>
                        <td width="30%">{{data?.RB_CAT_ZAKAT_FUND | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%">10.</td>
                        <td width="60%">Others, if any (provide detail)</td>
                        <td width="30%">{{others | currencySeparatorBD }}</td>
                    </tr>
                    <tr>
                        <td width="10%">11.</td>
                        <td width="60%">Total Investment (aggregate of 1 to 10)</td>
                        <td width="30%">
                            {{ totalInvestment | currencySeparatorBD }}
                        </td>
                    </tr>
                    <tr>
                        <td width="10%">12.</td>
                        <td width="60%">Amount of Tax Rebate </td>
                        <td width="30%">{{returnData?.taxPaymentData?.tc_Tax_Rebate_Amt | currencySeparatorBD }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
